import apiHandler from './apiHandler';

const CreateBooking = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/createBooking',
      method: 'POST',
      data: request,
    });

    if (response.response_code == 200) {
      return response;
    } else {

      throw new Error(response.message || 'Failed to Create Booking');
    }
  } catch (error) {
    console.error("Error Creating Booking", error);
    throw error;
  }
};

export default CreateBooking;